module.exports = __webpack_public_path__ + "img/1000.7833b32a.png";